import axiosInstance from "./axiosInstance";
import { API_URL } from "../constants";

/**
 * Ouvre un flux SSE authentifié par un TOKEN DE FLUX à courte durée (2 min) — jamais le JWT de session.
 * Récupère d'abord le token via /api/realtime/stream-token (en-tête Bearer), puis ouvre l'EventSource
 * avec ?token=. Gère la reconnexion (avec un token FRAIS) en cas de coupure / expiration.
 *
 * @param {string} path      chemin du flux, ex. "/api/notification/stream"
 * @param {string} eventName nom de l'événement SSE, ex. "notification"
 * @param {function} onEvent callback exécuté à chaque événement reçu
 * @returns {function} fonction de nettoyage (à appeler au démontage)
 */
export function openSse(path, eventName, onEvent) {
    let es = null;
    let closed = false;
    let retryTimer = null;

    const connect = async () => {
        if (closed) return;
        try {
            const { data } = await axiosInstance.get("/api/realtime/stream-token");
            const token = data && data.token;
            if (closed || !token || !API_URL) return;
            es = new EventSource(`${API_URL}${path}?token=${encodeURIComponent(token)}`);
            es.addEventListener(eventName, () => { if (!closed) onEvent(); });
            es.onerror = () => {
                // Coupure ou token expiré : on ferme et on retente avec un token frais (backoff 5 s).
                try { if (es) es.close(); } catch (e) { /* noop */ }
                es = null;
                if (!closed) {
                    clearTimeout(retryTimer);
                    retryTimer = setTimeout(connect, 5000);
                }
            };
        } catch (e) {
            if (!closed) {
                clearTimeout(retryTimer);
                retryTimer = setTimeout(connect, 10000);
            }
        }
    };

    connect();

    return () => {
        closed = true;
        clearTimeout(retryTimer);
        try { if (es) es.close(); } catch (e) { /* noop */ }
    };
}
